"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fp = _interopRequireDefault(require("lodash/fp"));

var _DrawerLink = _interopRequireDefault(require("@fe/ui/Drawer/DrawerLink"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DrawerEntry = function DrawerEntry(props) {
  var name = _fp.default.getOr('UNKNOWN ROUTE', "".concat(props.route, ".name"), props.routes);

  var url = props.currentItemId ? "/".concat(props.currentItemId, "/").concat(props.route) : "/".concat(props.route);

  var active = _fp.default.equals(props.currentPath, url);

  return /*#__PURE__*/_react.default.createElement(_DrawerLink.default, {
    name: name,
    icon: props.icon,
    to: url,
    active: active,
    onClick: props.onClick
  });
};

DrawerEntry.propTypes = {
  route: _propTypes.default.string,
  icon: _propTypes.default.node,
  currentItemId: _propTypes.default.any,
  currentPath: _propTypes.default.any,
  routes: _propTypes.default.object.isRequired
};
var _default = DrawerEntry;
exports.default = _default;